import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Sidebar from './components/Sidebar';
import EntrepriseProfile from './components/EntrepriseProfile';
import EntrepriseQuotes from './components/EntrepriseQuotes';
import EntrepriseProducts from './components/EntrepriseProducts';
import EntrepriseCart from './components/EntrepriseCart';
import EntrepriseInvoices from './components/EntrepriseInvoices';
import EntrepriseComplaints from './components/EntrepriseComplaints';
import './DashboardEntreprise.css';

const API_URL = import.meta.env.VITE_API_URL;

const DashboardEntreprise = ({onLogout}) => {
    const [activeTab, setActiveTab] = useState('overview');
    const [user, setUser] = useState(null);
    const [stats, setStats] = useState({
        quotesCount: 0,
        ordersCount: 0,
        savings: '0'
    });

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        try {
            const token = localStorage.getItem('token');
            const [profileRes, quotesRes] = await Promise.all([
                axios.get(`${API_URL}/auth/profile`, {headers: {Authorization: `Bearer ${token}`}}),
                axios.get(`${API_URL}/demandes-devis/mes-demandes`, {headers: {Authorization: `Bearer ${token}`}})
            ]);

            setUser(profileRes.data);

            const quotes = quotesRes.data || [];
            setStats({
                quotesCount: quotes.length,
                pendingQuotes: quotes.filter(q => q.statut === 'en_attente').length,
                ordersCount: 0, // À implémenter quand les commandes seront là
                savings: (quotes.length * 1.5).toFixed(1) // Simulation d'économies
            });
        } catch (error) {
            console.error('Erreur data initial:', error);
        }
    };

    const renderContent = () => {
        switch (activeTab) {
            case 'overview':
                return (
                    <div className="overview-container">
                        <div className="welcome-banner">
                            <h1>Bienvenue, {user?.nomEntreprise || 'Partenaire'}</h1>
                            <p>Maximisez votre rentabilité avec nos conditions B2B exclusives.</p>
                        </div>

                        {/* 1ère Section : Programme Excellence Partenaire */}
                        <div className="discount-packs-section">
                            <div className="section-header-inline">
                                <div>
                                    <h2>Programme Excellence Partenaire</h2>
                                    <p className="section-subtitle">Votre remise actuelle est basée sur votre volume d'activité annuel.</p>
                                </div>
                                <div className="current-status-badge">Niveau Actuel: <strong>Bronze</strong></div>
                            </div>
                            <div className="ent-packs-grid">
                                <div className="ent-pack-card bronze active">
                                    <div className="ent-pack-icon">🥉</div>
                                    <div className="ent-pack-badge">Statut Bronze</div>
                                    <div className="ent-pack-discount">7%</div>
                                    <div className="ent-pack-range">ACTIF</div>
                                    <p>Avantage de base sur tout le catalogue.</p>
                                </div>
                                <div className="ent-pack-card silver">
                                    <div className="ent-pack-icon">🥈</div>
                                    <div className="ent-pack-badge">Statut Silver</div>
                                    <div className="ent-pack-discount">10%</div>
                                    <div className="ent-pack-range">Prochain Palier</div>
                                    <p>Débloqué à 20k DT de volume cumulé.</p>
                                </div>
                                <div className="ent-pack-card gold">
                                    <div className="ent-pack-icon">🥇</div>
                                    <div className="ent-pack-badge">Statut Gold</div>
                                    <div className="ent-pack-discount">12%</div>
                                    <div className="ent-pack-range">Objectif VIP</div>
                                    <p>Accès aux prix d'usine et livraison offerte.</p>
                                </div>
                            </div>
                        </div>

                        {/* Section Boosters Business (Remplace les stats) */}
                        <div className="business-boosters-section">
                            <h2>Opportunités & Croissance</h2>
                            <div className="boosters-grid">
                                <div className="booster-card hot-deal">
                                    <div className="booster-tag">OFFRE FLASH</div>
                                    <div className="booster-content">
                                        <h3>Stock Prioritaire : Huawei FusionCharge</h3>
                                        <p>Arrivée prévue le 15 Mars. Réservez maintenant pour garantir votre prix B2B.</p>
                                        <button className="booster-btn" onClick={() => setActiveTab('products')}>Voir le stock</button>
                                    </div>
                                </div>
                                <div className="booster-card incentive">
                                    <div className="booster-tag">BONUS VOLUME</div>
                                    <div className="booster-content">
                                        <h3>Objectif Trimestriel</h3>
                                        <p>Encore <strong>8,500 DT</strong> pour débloquer un cashback de 2% sur vos prochaines commandes.</p>
                                        <div className="progress-mini-bar">
                                            <div className="progress-fill" style={{width: '60%'}}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="booster-card tech-support">
                                    <div className="booster-tag">SERVICE +</div>
                                    <div className="booster-content">
                                        <h3>Support Chantier Prioritaire</h3>
                                        <p>Besoin d'aide sur une installation ? Votre accès Gold vous donne une ligne directe.</p>
                                        <button className="booster-btn secondary" onClick={() => setActiveTab('reclamations')}>Contacter l'expert</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="quick-actions">
                            <h2>Accès Rapide</h2>
                            <div className="action-buttons">
                                <button className="primary-action" onClick={() => setActiveTab('products')}>Accéder au Catalogue B2B</button>
                                <button className="secondary-action" onClick={() => setActiveTab('quotes')}>Gestion des Devis</button>
                            </div>
                        </div>
                    </div>
                );
            case 'profile': return <EntrepriseProfile />;
            case 'quotes': return <EntrepriseQuotes />;
            case 'products': return <EntrepriseProducts />;
            case 'factures': return <EntrepriseInvoices />;
            case 'reclamations': return <EntrepriseComplaints />;
            case 'cart': return <EntrepriseCart />;
            default: return <div>Sélectionnez une option</div>;
        }
    };

    return (
        <div className="entreprise-dashboard-layout">
            <Sidebar
                activeTab={activeTab}
                onTabChange={setActiveTab}
                onLogout={onLogout}
            />
            <main className="entreprise-main-content">
                <header className="entreprise-header">
                    <div className="header-left">
                        <div className="entreprise-search">
                            <span className="search-icon">🔍</span>
                            <input type="text" placeholder="Rechercher un dossier, une facture..." />
                        </div>
                    </div>

                    <div className="header-right">

                        <div className="header-divider"></div>
                        <div className="user-profile-menu">
                            <div className="user-info-text text-right">
                                <span className="user-name">{user?.nomEntreprise || 'Partenaire'}</span>
                                <br />
                                <span className="user-role">Accès Entreprise</span>
                            </div>
                            <div className="user-mini-avatar">
                                {user?.nomEntreprise?.charAt(0) || 'E'}
                            </div>
                        </div>
                    </div>
                </header>

                <div className="content-inner">
                    {renderContent()}
                </div>
            </main>
        </div>
    );
};

export default DashboardEntreprise;
